<template>
  <div>
    <div class="title">手机号登录/注册</div>
    <van-cell-group class="form">
      <van-field v-model.trim="form.mobile" :clearable="true" label="手机号" placeholder="请输入手机号" />
      <van-field v-model.trim="form.code" label="验证码" placeholder="请输入验证码">
        <van-button :disabled="form.mobile.length!=11" class="btn-getcode" :class="form.mobile.length==11?'btn-canclick':'btn-cantclick'" @click="getCode" v-if="sendAuthCode" slot="button" size="small" type="primary">发送验证码</van-button>
        <van-button disabled slot="button"  size="small" class="btn-cantclick" v-else>{{auth_time}}</van-button>
      </van-field>
    </van-cell-group>
    <div class="title">手机号登录/注册</div>
    <div class="form-button">
      <van-button type="primary" :class="form.mobile.length==11 && form.code?'btn-canclick':'btn-cantclick'" class="bg-green btn-confirm" @click="submit">登录</van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Toast, Field } from "vant";
import { login,sendVerificationCode } from "../api/api-app";
import {listChildInfo} from '../api/api-child';
export default {
  name: "login",
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      childInfo: state => state.childInfo,
      activeChildInfo: state => state.activeChildInfo
    })
  },
  data() {
    return {
      form:{
        mobile:"",
        code:""
      },
      activeChildIndex:0,
      sendAuthCode:true,
      auth_time:0
    };
  },
  created() {
    console.log("login")
  },
  methods: {
    submit(){
      if(!this.form.mobile || !this.form.code){
        Toast.fail("请输入全部信息");
        return false
      }
      if(this.form.mobile.length!=11){
        Toast.fail("请输入正确的手机号码");
        return false
      }
      login(this.form).then(res=>{
        if(res.code == 200){
          this.$store.dispatch("setUserInfo",res.data);
          this.$router.push("/index")
        }else{
          Toast.fail(res.msg);
        }
      })
    },
    getCode(){
      if(this.form.mobile.length==11){
        sendVerificationCode(this.form.mobile).then(res=>{
          if(res.code == 200){
            this.sendAuthCode = false;
            this.auth_time = 60;
            var auth_timetimer = setInterval(()=>{
              this.auth_time--;
              if(this.auth_time<=0){
                this.sendAuthCode = true;
                clearInterval(auth_timetimer);
              }
            }, 1000);
          }else{
            Toast.fail(res.msg);
          }
        })
        
      }else{
        Toast.fail("请输入正确的手机号码");
      }
    },
  }
};
</script>
<style scoped lang="less">
.title{
  font-size:25px;
  font-weight:500;
  color:rgba(51,51,51,1);
  text-align: center;
  padding: 70px 0;
}
.van-cell-group{
  width: 100%
}
.van-field /deep/ .van-field__label{
  font-size:18px;
  font-weight:600;
  color:rgba(51,51,51,1);
}
.van-cell{
  width: auto;
  height: 50px;
  padding: 10px 0;
  margin: 0 20px
}

.btn-canclick{
  background:rgba(135,226,205,1);
  border: none;
  color: #fff
}
.btn-cantclick{
  background:rgba(225,224,225,1);
  border: none;
  color: #fff
}
.btn-getcode{
  border-radius: 20px
}
.btn-confirm{
  bottom: 40px;
  width: 335px;
  left:20px;
  color: #fff;
  font-size: 16px;
  border-radius:22px;
  margin: 80px auto
}
</style>
